import { render } from "./ForgotPasswordPage.vue?vue&type=template&id=58516fb0&ts=true"
import script from "./ForgotPasswordPage.vue?vue&type=script&lang=ts"
export * from "./ForgotPasswordPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Authentication/ForgotPasswordPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "58516fb0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('58516fb0', __exports__)) {
    api.reload('58516fb0', __exports__)
  }
  
  module.hot.accept("./ForgotPasswordPage.vue?vue&type=template&id=58516fb0&ts=true", () => {
    api.rerender('58516fb0', render)
  })

}


export default __exports__